<new-auth-page
  [page]="'signin'"
>
  <div left>
    <h1>Welcome to login</h1>
    <p>Don't have an account?</p>
    <a [routerLink]="['/register']" class="link" trans>Register</a>
  </div>
  <form
    form
    [formGroup]="form"
    *ngIf="errResponse$ | async as errors"
    ngNativeValidate
  >
    <div class="header" [transValues]="{siteName: settings.get('branding.site_name')}" trans>
      {{ route.snapshot.data.message || 'Sign in to your account' }}
    </div>

    <!-- <button
      type="button"
      class="no-style alternative-signin-method"
      (click)="socialAuth.loginWith('envato')"
      *ngIf="settings.get('social.envato.enable'); else defaultSocialAuth"
    >
      <mat-icon svgIcon="envato-custom"></mat-icon>
      <span trans>Sign in with Envato instead</span>
    </button> -->

    <ng-container 
      *ngIf="settings.get('social.twitter.enable') || settings.get('social.facebook.enable') || settings.get('social.google.enable')"
    >
      <div class="social-options">
        <!-- <button
          class="facebook"
          type="button"
          (click)="socialAuth.loginWith('facebook')"
          *ngIf="settings.get('social.facebook.enable')"
        >
          <mat-icon svgIcon="facebook"></mat-icon>
          Login with Facebook
        </button> -->
        <!-- <button
          class="google"
          type="button"
          (click)="socialAuth.loginWith('google')"
          *ngIf="settings.get('social.google.enable')"
        >
          <mat-icon svgIcon="google"></mat-icon>
          Login with Google
        </button> -->
        <!-- <button
          class="twitter"
          type="button"
          (click)="socialAuth.loginWith('twitter')"
          *ngIf="settings.get('social.twitter.enable')"
        >
          <mat-icon svgIcon="twitter"></mat-icon>
          Login with Twitter
        </button> -->
      </div>
      <!-- <div class="hr-lines">Or</div> -->
    </ng-container>

    <div class="many-inputs">
      <div class="input-container">
        <input type="email" formControlName="email" id="login-email" required placeholder="Enter Email Address" />
        <p class="error big-error" *ngIf="errors.email">
          <mat-icon svgIcon="warning"></mat-icon>
          <span>{{ errors.email }}</span>
        </p>
      </div>

      <div class="input-container">
        <div class="password-field">
          <input [type]="password" formControlName="password" id="login-password" required placeholder="Enter Password" />
          <span class="toggle" (click)="toggleshow()">
            <i class="fa fa-eye" aria-hidden="true" *ngIf="!show"></i>
            <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="show"></i>
          </span>
        </div>

        <p class="error big-error" *ngIf="errors.password">
          <mat-icon svgIcon="warning"></mat-icon>
          <span>{{ errors.password }}</span>
        </p>
      </div>
    </div>

    <a class="forgot-password" [routerLink]="['/forgot-password']" tabindex="-1" trans>
      Forgot your password ?
    </a>

    <mat-checkbox
      name="remember-me"
      class="remember-me"
      color="accent"
      formControlName="remember"
      trans
    >
      Stay signed in for a month
    </mat-checkbox>

    <button
      type="submit"
      [disabled]="loading$ | async"
      (click)="login()"
      trans
    >
      Login
    </button>
  </form>
</new-auth-page>
